import React from 'react';
import axios from 'axios';
import { useContext } from 'react';
import { UserContext } from '../context/UserContext.js';
import MessageSnackBar from './MessageSnackBar.js';
import SimpleGrid from './SimpleGrid.js';

import { 
    Button, 
    Grid,
    Paper ,
    } from '@mui/material';

const MessageInfo = (props) => {
    //SECTION USER CONTEXT and HEADERS
    const userData = useContext(UserContext);
    const storedHeaders = sessionStorage.getItem('headers');
    const headers = storedHeaders ? JSON.parse(storedHeaders) : {};
    // !SECTION

    //SECTION Message Bar Controls
      const [ messageBarMessage, setMessageBarMessage ] = React.useState('');
      const [ messageBarOpen, setMessageBarOpen ] = React.useState(false);
      const [ messageSeverity, setMessageSeverity ] = React.useState('success');


      const handleMessageBarClosing = () => {
        setMessageBarOpen(false);
      };
      //!SECTION

    //SECTION Component Controls
    const itemMessage = 'Mobile Messages Information'; //!change this to change the message

    const toggleItems = () => {
      if (viewItems){
          setViewItems(false);
          setViewItemsMessage(`View ${itemMessage}`);
      }else{
          // getWarehouseList(userData.email)
          setViewItems(true);
          setViewItemsMessage(`Hide ${itemMessage}`);
      };
  } ;

    const [ viewItems, setViewItems ] = React.useState(false);
    const [ viewItemsMessage, setViewItemsMessage ] = React.useState(`View ${itemMessage}`);

    //!SECTION


  // SECTION Add new capabilities here
    React.useEffect(() => {
        getData(userData);
    }, []);

    const [ displayData, setdisplayData ] = React.useState([]);

    const getData = (userData) => {

        const property = "deleted"; //!set this 
        const statusRequest = "false"; //!set this
        // const URL = `Dashboard/currentshelflist/${selectedAccount}/${warehouse}`; //!set this
        const URL = `Messages/mobilemessages?accountcode=${userData.accountCode}&property=${property}&status=${statusRequest}`; //!set this
        axios.get(URL, 
          {headers: headers})
        .then(function (response) {
          setdisplayData(response.data.message);
          // console.log("Response: ", response.data.message);
        })
        .catch(function (error) {
          if (error.response.status === 401) {
            alert ("Your session has expired. Please login again.");
          }
          if (error.response.status !== 401) {
            setMessageBarMessage(`Sorry! User info is not available at this time. ${error.message}`);
            setMessageBarOpen(true);
            setMessageSeverity("error") // error: red, warning: orange, information: blue, success: green
          }
        })
        .then(function () {
          // always executed
        });
      }

    //!SECTION

    //SECTION GRID variables

    //! set to preference
    const visibleColumns = {
      id: false,
      // serialNum: false,
      };

    const filterModel = {
      items: [
      ]
    };
    // some things are defined in the grid component
    const pinnedModel = ['recipient'];
    // const pinnedModel = ['warehouseName','warehouseNumber']  ;
    const sortModel = [];
    // const sortModel = [{ field: "inventoryCount"}];
    const nonAdminUser = userData.userRole !== 10 ? true : false;
    const  displayItems  = {
      columns: [
      {field: 'id', hide: true},
      {field: 'recipient', headerName: 'Recipient', width:250, headerAlign: 'center', align: 'center',  editable: false},
      {field: 'trackingNumber', headerName: 'Tracking', width:200, headerAlign: 'center', align: 'center',  editable: false},
      {field: 'itemNumber', headerName: 'Item Number', width:100, headerAlign: 'center', align: 'center',  editable: false},
      {field: 'timestamp', headerName: 'Created Date', width:125, headerAlign: 'center', align: 'center', editable: false},
      {field: 'sender', headerName: 'Sender', width:125, headerAlign: 'center', align: 'center', editable: false},
      {field: 'content', 
        headerName: 'Content',
        width:900,
        headerAlign: 'center',
        align: 'center',
        editable: false,
        renderCell: (params) => {
          return (
            <div style={{ 
              whiteSpace: 'normal', 
              wordBreak: 'break-word', 
              overflow: 'visible',
              lineHeight: '1.2', 
              padding: '4px'
            }}>
              {params.value}
            </div>
          );
        }
    
      },
      ], 
      rows: displayData
      };


      //!SECTION

      

  return (  

        <>
      <Grid
        item
        xs={12}
        md={12}
        lg={12}
        sx={{ alignContent: "center", border: 0 }}
      >
        <Paper
          sx={{ p: 2, display: "flex", flexDirection: "column" }}
        >
          <Button onClick={toggleItems}>
            {" "}
            {viewItemsMessage}
          </Button>

          {/* Warehouse Filters */}
          

          {viewItems && 
          <>
        <MessageSnackBar messageBarMessage={messageBarMessage} messageBarOpen={messageBarOpen} handleMessageBarClosing={handleMessageBarClosing} messageSeverity={messageSeverity} />
        
        <Grid
          container
          justifyContent={"center"}
          sx={{marginBottom:4, marginTop:2}}
          >


          {/* //SECTION - Grid */}
          <Grid
          item
          xs={12}
          md={12}
          lg={12}
          sx={{ alignContent: "center", border: 0 }}
          >
        <SimpleGrid 
        gridColumns={displayItems.columns}
        gridData={displayItems.rows}
        visibleColumns={visibleColumns}
        sortModel={sortModel}
        pinnedColumns={pinnedModel}
        />
          </Grid>
          {/* //!SECTION */}


          </Grid>

      </>
    }
        </Paper>
      </Grid>
  </>


  );
};
export default MessageInfo;